import React from 'react'
import './styles/anchor.scss'
import { Link } from 'react-router-dom'

const Anchor = (props) => {
    const {
        children, cssClass, onClick, style, href, isExternal, target, title,
    } = props

    if (!href) {
        return (
            <div style={style} onClick={onClick} className={`anchor ${cssClass || ''}`} title={title}>
                {children}
            </div>
        )
    }
    if (isExternal) {
        return (
            <a style={style} href={href} onClick={onClick} target={target} className={`anchor ${cssClass || ''}`} title={title}>
                {children}
            </a>
        )
    }
    return (
        <Link style={style} to={href} onClick={onClick} className={`anchor ${cssClass || ''}`} title={title}>
            {children}
        </Link>
    )
}

export default Anchor